import Button from "@components/Button"
import Layout from "@components/Layout"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

const COACHING_FEATURES = [
  { emoji: "⏰", key: "pages.onboarding.whatsAppCoaching.features.reminders" },
  { emoji: "📊", key: "pages.onboarding.whatsAppCoaching.features.summary" },
  {
    emoji: "🤝",
    key: "pages.onboarding.whatsAppCoaching.features.accountability",
  },
]

export default function WhatsAppCoaching() {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="flex grow flex-col pt-4">
        <div className="mb-2 text-center text-4xl">💬</div>

        <h1 className="custom-heading mb-2">
          {t("pages.onboarding.whatsAppCoaching.heading")}
        </h1>

        <p className="mb-8 text-center text-sm leading-relaxed text-gray-500">
          {t("pages.onboarding.whatsAppCoaching.info")}
        </p>

        <div className="space-y-3">
          {COACHING_FEATURES.map((feature) => (
            <div
              key={feature.key}
              className="flex items-center gap-4 rounded-2xl bg-white px-5 py-4"
            >
              <span className="text-2xl">{feature.emoji}</span>
              <p className="text-custom-charcoal text-sm font-semibold">
                {t(feature.key)}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-custom-teal-light mt-6 rounded-2xl px-5 py-4 text-center">
          <p className="text-custom-teal-dark text-sm font-semibold">
            {t("pages.onboarding.whatsAppCoaching.stat")}
          </p>
        </div>
      </div>

      <div className="sticky bottom-0 -mx-5 bg-gradient-to-t from-white from-70% to-transparent px-5 pt-8 pb-4">
        <Form method="post" onSubmit={handleSubmit}>
          <input name="whatsAppCoaching" type="hidden" value="continue" />
          <Button title={t("shared.continue")} type="submit" />
        </Form>
      </div>
    </Layout>
  )
}
